module.exports = __webpack_public_path__ + "static/media/RoundedRect_Green@2x.f2487816.png";